// Singleton oidc-client-ts UserManager + token accessor used by the axios client.
import { User, UserManager } from 'oidc-client-ts';
import { oidcSettings } from './config.js';

export const userManager = new UserManager(oidcSettings);

// Cache the latest access token so the axios request interceptor stays synchronous.
let cachedAccessToken: string | null = null;

export function setCachedAccessToken(token: string | null): void {
  cachedAccessToken = token;
}

export function getCachedAccessToken(): string | null {
  return cachedAccessToken;
}

// Keep the cache fresh as oidc-client-ts loads / renews / unloads the user.
userManager.events.addUserLoaded((user: User) => {
  setCachedAccessToken(user.access_token ?? null);
});
userManager.events.addUserUnloaded(() => {
  setCachedAccessToken(null);
});
userManager.events.addSilentRenewError(() => {
  // Leave the cache as-is; the AuthContext surfaces the eventual 401.
});
